import './Lib/i18n'
import 'react-simple-flex-grid/lib/main.css'
import 'react-toastify/dist/ReactToastify.css'
import 'react-loading-skeleton/dist/skeleton.css'

import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

import { SuspenseLoading } from './Components'
import { AuthorizedLayout, UnauthorizedLayout } from './Layouts'
import { useAuth } from './Providers/AuthProvider'
import { MediaQueriesProvider } from './Providers/MediaQueriesProvider'

const LoginOrMain: React.FC = (): JSX.Element => {
  const { status } = useAuth()
  if (status === 'loading') return <SuspenseLoading />
  return status === 'authenticated' ? <AuthorizedLayout /> : <UnauthorizedLayout />
}

const App: React.FC = (): JSX.Element => {
  return (
    <div id="AppWrapper">
      <MediaQueriesProvider>
        <ToastContainer position="bottom-right" newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable />
        <Router>
          <LoginOrMain />
        </Router>
      </MediaQueriesProvider>
    </div>
  )
}
export default App
